var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrength(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 410.46 416.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff200;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.38,
    y1: 201.34,
    x2: 388.6,
    y2: 201.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 202.87,
    y1: 398.86,
    x2: 388.6,
    y2: 201.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.38,
    y1: 201.34,
    x2: 202.87,
    y2: 398.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 129.92,
    y1: 109.23,
    x2: 129.13,
    y2: 259.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 269.32,
    y1: 109.73,
    x2: 269.32,
    y2: 259.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 129.92,
    y1: 109.23,
    x2: 269.32,
    y2: 109.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 129.13,
    y1: 259.99,
    x2: 269.32,
    y2: 259.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 203.94,
    y1: 394.39,
    x2: 203.9,
    y2: 24.67
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "129.92 130.71 125.1 115.87 109.49 115.87 122.12 106.69 117.3 91.85 129.92 101.02 142.55 91.85 137.73 106.69 150.35 115.87 134.75 115.87 129.92 130.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "192.42 42.82 196.28 27.7 183.09 19.36 198.66 18.35 202.52 3.23 208.29 17.73 223.86 16.73 211.85 26.69 217.62 41.2 204.43 32.85 192.42 42.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "261.58 129.77 262.43 114.18 247.87 108.57 262.95 104.55 263.79 88.97 272.27 102.07 287.35 98.06 277.51 110.17 285.99 123.28 271.42 117.66 261.58 129.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "253.94 274.99 261.2 261.17 250.29 250 265.68 252.63 272.93 238.81 275.19 254.26 290.57 256.88 276.58 263.8 278.84 279.24 267.93 268.08 253.94 274.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "117.65 278.14 121.51 263.02 108.31 254.68 123.89 253.67 127.75 238.55 133.51 253.05 149.09 252.05 137.08 262.02 142.85 276.52 129.66 268.18 117.65 278.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "223.58 405.73 206.18 402.76 192.59 414.03 195.57 396.63 184.29 383.04 201.69 386.02 215.28 374.74 212.31 392.14 223.58 405.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "29.9 221.87 20.31 207.04 2.81 204.67 17.64 195.08 20.01 177.58 29.6 192.41 47.1 194.78 32.27 204.37 29.9 221.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "385.83 223.83 379.04 207.53 362.24 202.07 378.54 195.28 384 178.49 390.79 194.79 407.58 200.25 391.28 207.04 385.83 223.83"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrength);
export default __webpack_public_path__ + "static/media/Strength.90f85b2afb435a5e42789115aa6691a9.svg";
export { ForwardRef as ReactComponent };